import { render, staticRenderFns } from "./RegionAddNew.vue?vue&type=template&id=6dee7d0a&"
import script from "./RegionAddNew.vue?vue&type=script&lang=js&"
export * from "./RegionAddNew.vue?vue&type=script&lang=js&"
import style0 from "./RegionAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports